import firebase from 'firebase'

export const runAutoPairing = async (registrationWeekStartDate: number) => {

    const callable = firebase.functions().httpsCallable('runPairRegistrations')
    return callable({ registrationWeekStartDate } as { registrationWeekStartDate: number })
    
}